const SENTENCE_TERMINATORS = new Set([".", "!", "?"]);

export type PendingSentenceSegment = {
  startIndex: number;
  endIndex: number;
  text: string;
};

function getNextSentenceBoundary(text: string, startIndex: number): number | null {
  for (let i = startIndex; i < text.length; i++) {
    const currentChar = text[i];

    if (currentChar === "\n") {
      let boundary = i + 1;
      while (boundary < text.length && /\s/.test(text[boundary])) {
        boundary += 1;
      }
      return boundary;
    }

    if (!SENTENCE_TERMINATORS.has(currentChar)) {
      continue;
    }

    let lookahead = i + 1;
    while (lookahead < text.length && /["')\]]/.test(text[lookahead])) {
      lookahead += 1;
    }

    if (lookahead < text.length && !/\s/.test(text[lookahead])) {
      continue;
    }

    let boundary = lookahead;
    while (boundary < text.length && /\s/.test(text[boundary])) {
      boundary += 1;
    }
    return boundary;
  }

  return null;
}

export function collectPendingSentenceSegments(
  text: string,
  startIndex: number,
  flushTrailingText: boolean,
): PendingSentenceSegment[] {
  const segments: PendingSentenceSegment[] = [];
  let cursor = startIndex;

  while (cursor < text.length) {
    const boundary = getNextSentenceBoundary(text, cursor);
    if (boundary == null) {
      break;
    }

    const segmentText = text.slice(cursor, boundary);
    if (segmentText.trim().length > 0) {
      segments.push({
        startIndex: cursor,
        endIndex: boundary,
        text: segmentText,
      });
    }
    cursor = boundary;
  }

  if (flushTrailingText && cursor < text.length) {
    const trailingText = text.slice(cursor);
    if (trailingText.trim().length > 0) {
      segments.push({
        startIndex: cursor,
        endIndex: text.length,
        text: trailingText,
      });
    }
  }

  return segments;
}
